export default {
	state: {
		navBar: {
			active: '0',
			list: []
		}
	},
	getters: {
		// 首頁
		adminIndex(state) {
			if (state.navBar.list.length === 0) {
				return 'error_404'
			}

			let item = state.navBar.list[0].submenu[0]
			//console.log(state.navBar);
			if (item) {
				return item.pathname
			}
		}
	},
	mutations: {
		// 創建菜單
		createNavBar(state, menus) {
			let list = menus.map(item => {
				let submenu = item.child.map(v => {
					let san = v.child.map(i => {
						return {
							icon: i.icon,
							name: i.name,
							is_num: i.is_num,
							pathname: i.desc
						}
					})

					return {
						icon: v.icon,
						name: v.name,
						is_num: v.is_num,
						pathname: v.desc,
						child:san
					}
				})
				return {
					name: item.name,
					is_num: item.is_num,
					subActive: '0',
					submenu: submenu
				}
			})
			state.navBar.list = list
			//console.log(state.navBar.list);
			window.sessionStorage.setItem('navBar', JSON.stringify(state.navBar));
		},
		initNavBar(state) {
			let navBar = window.sessionStorage.getItem('navBar')
			navBar = navBar ? JSON.parse(navBar) : {
					active: '0',
					list: []
				},
				state.navBar = navBar
		}
	},
	actions: {

	}
}
